import React from 'react';
import { VideoPlayerRef } from '../../shared/interfaces/VideoPlayerRef';
import VideoPlayer from 'components/Media/VideoPlayer/VideoPlayer';

type Props = {
  url: string;
  startTime?: number;
  endTime?: number;
  thumbnail?: string | boolean;
  playIcon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  classes?: {
    root: string;
    videoPlayer: string;
    icon: string;
  };
  key?: string;
  onEnded?: () => void;
  autoPlay?: boolean;
  isSmall?: boolean;
};

const CustomVideoPlayer = React.forwardRef<VideoPlayerRef, Props>(({ url }) => {
  return <VideoPlayer url={url} />;
});

export default CustomVideoPlayer;
